<!-- <app-header *ngIf="isAuth()"></app-header>
<mat-sidenav-container class="example-container">
    <mat-sidenav class = " sidenav" #sidenav mode="side" [(opened)]="opened" [hidden]= "!isAuth()"> 
      Sidenav content

      <mat-nav-list>
        <mat-list-item >
           <a matLine href="..."> link</a>
           <button mat-icon-button >
              <mat-icon>info</mat-icon>
           </button>
        </mat-list-item>
        <mat-list-item >
            <a matLine href="..."> link</a>
            <button mat-icon-button >
               <mat-icon>info</mat-icon>
            </button>
         </mat-list-item>
      </mat-nav-list>
   
    </mat-sidenav>
  
    <mat-sidenav-content>
      <div class="container">
  
        <router-outlet></router-outlet>
      
    </div>
    </mat-sidenav-content>
  </mat-sidenav-container> 


<app-footer *ngIf="isAuth()"></app-footer> -->

<div class="box">
   <app-header *ngIf="isAuth()"></app-header>
   <mat-sidenav-container class="box-container">
      <mat-sidenav class=" sidenav" #sidenav mode="side" [(opened)]="show">
         <mat-nav-list>
            <mat-list-item class="nav-item" routerLinkActive="active">
               <a matLine [routerLink]="['report']">
                  <button mat-icon-button>
                     <mat-icon>insert_drive_file</mat-icon>
                  </button>
                  Informes
               </a>
            </mat-list-item>
            

            <mat-list-item class="nav-item" *ngIf="isAllowed('ROLE_ORDER_ENTRY') || env.show_disabled_modules"  [disabled] = "!isAllowed('ROLE_ORDER_ENTRY')" (click)="isAllowed('ROLE_ORDER_ENTRY') ? 'showSubMenu=!showSubMenu' : null">
               <a matLine [class.disabled]="!isAllowed('ROLE_ORDER_ENTRY')">
                  <button mat-icon-button>
                     <mat-icon>move_to_inbox</mat-icon>
                  </button>
                  Solicitudes
               </a>
               <button mat-icon-button *ngIf="!isAllowed('ROLE_ORDER_ENTRY')">
                  <mat-icon class="lock">lock</mat-icon>
               </button>
            </mat-list-item>


            <div class="submenu fadeIn fadeOut" [hidden]="!showSubMenu" [class.disabled]="!isAllowed('ROLE_ORDER_ENTRY')">
               <mat-list-item class="nav-subitem" routerLinkActive="active" *ngIf="isAllowed('ROLE_ORDER_ENTRY') || env.show_disabled_modules">
                  <a matLine [routerLink]="['order-entry/new-order']" [class.disabled]="!isAllowed('ROLE_ORDER_ENTRY')">
                     <button mat-icon-button>
                        <mat-icon>library_add</mat-icon>
                     </button>
                     Ingreso
                     <button mat-icon-button *ngIf="!isAllowed('ROLE_ORDER_ENTRY')">
                        <mat-icon class="lock">lock</mat-icon>
                     </button>
                  </a>
               </mat-list-item>
               <mat-list-item class="nav-subitem fadeIn fadeOut" routerLinkActive="active" [class.disabled]="!isAllowed('ROLE_ORDER_ENTRY')">
                  <a matLine [routerLink]="['order-entry/remittances']">
                     <button mat-icon-button>
                        <mat-icon>library_books</mat-icon>
                     </button>
                     Consulta
                     <button mat-icon-button *ngIf="!isAllowed('ROLE_ORDER_ENTRY')">
                        <mat-icon class="lock">lock</mat-icon>
                     </button>
                  </a>
               </mat-list-item>
            </div>


               <mat-list-item class="nav-item" [disabled] = "!isAllowed('ROLE_PHLEBOTOMY')" *ngIf="isAllowed('ROLE_PHLEBOTOMY') || env.show_disabled_modules"  routerLinkActive="active">
                  <a matLine [routerLink]="['order-entry/search-order']" [class.disabled]="!isAllowed('ROLE_PHLEBOTOMY')">
                     <button mat-icon-button>
                        <mat-icon>search</mat-icon>
                     </button>
                     Extracción
                     <button mat-icon-button *ngIf="!isAllowed('ROLE_PHLEBOTOMY')">
                        <mat-icon class="extraction lock">lock</mat-icon>
                     </button>
                  </a>
               </mat-list-item>
         </mat-nav-list>

      </mat-sidenav>

      <mat-sidenav-content>
         <app-loader></app-loader>
         <router-outlet></router-outlet>
      </mat-sidenav-content>
   </mat-sidenav-container>
</div>